import functions from '@mindthegapstudio/stpancras-storybook-app/src/plugins/functions'

const install = (Vue) => {
  Vue.prototype.$func = {
    ...functions,
  }
}

export default {
  install,
}
